import React from 'react';

import { Image } from '@blueprint/ui';
import { Text } from '@blueprint/text';
import { ArrowRightSmall } from '@blueprint/icons';
import {
    HeaderContainer,
    HeaderLeftColumn,
    HeaderRightColumn,
    ImageWrapper,
    LinkStyleButton,
    ResponsiveHeaderContainer,
    SummaryHeaderWrapper
} from './SummaryHeader.styles';

type Props = {
    name?: string | null;
    developerName?: string | null;
    logoUri?: string | null;
    ddpLink: string | null;
};

const SummaryHeader: React.FC<Props> = ({
    name,
    developerName,
    logoUri,
    ddpLink
}) => {
    return (
        <SummaryHeaderWrapper>
            <HeaderContainer>
                <HeaderLeftColumn>
                    <Text color="text-placeholder">Developer</Text>
                    <Text isBold size="6">
                        {developerName}
                    </Text>
                </HeaderLeftColumn>
                <HeaderRightColumn>
                    {!!logoUri && (
                        <ImageWrapper>
                            <Image
                                src={logoUri}
                                alt="developer logo"
                                lazy={false}
                            />
                        </ImageWrapper>
                    )}
                </HeaderRightColumn>
            </HeaderContainer>

            <ResponsiveHeaderContainer>
                <HeaderLeftColumn>
                    <Text size="7">{name} overview</Text>
                </HeaderLeftColumn>
                <HeaderRightColumn>
                    <div>
                        <LinkStyleButton
                            isDisplayedBlock={!ddpLink}
                            href={ddpLink || ''}
                        >
                            View development details
                            <ArrowRightSmall />
                        </LinkStyleButton>
                    </div>
                </HeaderRightColumn>
            </ResponsiveHeaderContainer>
        </SummaryHeaderWrapper>
    );
};

export default SummaryHeader;
